(function () {
  'use strict';

  var responses = Object.create(null);
  var originals = new WeakMap();
  var optionMaps = new WeakMap();
  var currentKey = '';
  var visibleObserver = null;
  var refreshQueued = false;
  var activeRequests = 0;
  var requestQueue = [];
  var requestLimit = 4;

  function preference() {
    return window.JMT_PREF && window.JMT_PREF.get ? window.JMT_PREF.get() : null;
  }

  function selections(pref) {
    if (!pref) return null;
    var selected = {
      pouchStyle: pref.pouchStyle || pref.cut,
      waistSize: pref.waistSize || pref.size,
      thongStrapStyle: pref.thongStrapStyle
    };
    return selected.pouchStyle && selected.waistSize && selected.thongStrapStyle ? selected : null;
  }

  function keyFor(pref) {
    var selected = selections(pref);
    return selected ? JSON.stringify([selected.pouchStyle, selected.waistSize, selected.thongStrapStyle]) : '';
  }

  function role(name) {
    return window.JMT_VARIANTS && window.JMT_VARIANTS.role ? window.JMT_VARIANTS.role(name) : '';
  }

  function normalized(name, value) {
    if (window.JMT_VARIANTS && window.JMT_VARIANTS.normalizeValue) {
      return window.JMT_VARIANTS.normalizeValue(name, value);
    }
    return String(value || '').trim().toLowerCase();
  }

  function optionMap(scope) {
    if (optionMaps.has(scope)) return optionMaps.get(scope);
    var data = [];
    var source = scope.querySelector('[data-jmt-option-values]');
    try {
      data = source ? JSON.parse(source.textContent) : [];
    } catch (error) {
      data = [];
    }
    optionMaps.set(scope, data);
    return data;
  }

  function selectedOptionIds(scope, pref) {
    var selected = selections(pref);
    if (!selected) return null;
    var ids = [];
    var rows = optionMap(scope);
    ['pouchStyle', 'waistSize', 'thongStrapStyle'].forEach(function (wantedRole) {
      var wantedValue = selected[wantedRole];
      var group = rows.find(function (item) {
        return role(item.option) === wantedRole;
      });
      var row = group && group.values.find(function (item) {
        return normalized(group.option, item[0]) === normalized(group.option, wantedValue);
      });
      if (row && row[1]) ids.push(String(row[1]));
    });
    return ids.length === 3 ? ids : null;
  }

  function runNextRequest() {
    while (activeRequests < requestLimit && requestQueue.length) {
      var task = requestQueue.shift();
      activeRequests += 1;
      task.run().then(task.resolve, task.reject).finally(function () {
        activeRequests -= 1;
        runNextRequest();
      });
    }
  }

  function limitedRequest(run) {
    return new Promise(function (resolve, reject) {
      requestQueue.push({ run: run, resolve: resolve, reject: reject });
      runNextRequest();
    });
  }

  function selectedPrice(handle, optionIds) {
    var cacheKey = handle + ':' + optionIds.join(',');
    if (!responses[cacheKey]) {
      responses[cacheKey] = limitedRequest(function () {
        var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
        var url = root + 'products/' + encodeURIComponent(handle) + '?section_id=jmt-collection-selected-price&option_values=' + optionIds.map(encodeURIComponent).join(',');
        return fetch(url, {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        }).then(function (response) {
          if (!response.ok) throw new Error('Selected price unavailable');
          return response.text();
        }).then(function (html) {
          var rendered = new DOMParser().parseFromString(html, 'text/html');
          var result = rendered.querySelector('[data-jmt-selected-price]');
          if (!result) throw new Error('Selected variant unavailable');
          return {
            id: result.dataset.variantId,
            price: result.dataset.price,
            comparePrice: result.dataset.comparePrice,
            onSale: result.dataset.onSale === 'true'
          };
        });
      }).catch(function (error) {
        delete responses[cacheKey];
        throw error;
      });
    }
    return responses[cacheKey];
  }

  function priceParts(scope) {
    var direct = scope.querySelector('[data-jmt-price-target]');
    if (direct) return { direct: direct };
    var root = scope.querySelector('.price');
    if (!root) return null;
    var regular = root.querySelector('.price__regular span.price-item--regular');
    var sale = root.querySelector('.price__sale .price-item--sale');
    if (!regular || !sale) return null;
    return {
      root: root,
      regular: regular,
      sale: sale,
      compare: root.querySelector('.price__sale .price-item--regular')
    };
  }

  function remember(scope, parts) {
    if (originals.has(scope)) return;
    if (parts.direct) {
      originals.set(scope, { direct: parts.direct.textContent });
      return;
    }
    originals.set(scope, {
      className: parts.root.className,
      regular: parts.regular.textContent,
      sale: parts.sale.textContent,
      compare: parts.compare && parts.compare.textContent
    });
  }

  function restore(scope) {
    var saved = originals.get(scope);
    if (!saved) return;
    var parts = priceParts(scope);
    if (!parts) return;
    if (parts.direct) {
      parts.direct.textContent = saved.direct;
      scope.removeAttribute('data-jmt-selected-variant-id');
      return;
    }
    parts.root.className = saved.className;
    parts.regular.textContent = saved.regular;
    parts.sale.textContent = saved.sale;
    if (parts.compare) parts.compare.textContent = saved.compare;
    var addedCompare = parts.root.querySelector('[data-jmt-added-compare]');
    if (addedCompare) addedCompare.remove();
    scope.removeAttribute('data-jmt-selected-variant-id');
  }

  function render(scope, selected) {
    var parts = priceParts(scope);
    if (!parts || !selected.price) return;
    remember(scope, parts);
    if (parts.direct) {
      parts.direct.textContent = selected.price;
      scope.setAttribute('data-jmt-selected-variant-id', selected.id);
      return;
    }
    parts.regular.textContent = selected.price;
    parts.sale.textContent = selected.price;
    parts.root.classList.toggle('price--on-sale', selected.onSale);
    if (selected.onSale && !parts.compare) {
      var wrapper = document.createElement('span');
      wrapper.setAttribute('data-jmt-added-compare', '');
      var strike = document.createElement('s');
      strike.className = 'price-item price-item--regular';
      wrapper.appendChild(strike);
      parts.root.querySelector('.price__sale').insertBefore(wrapper, parts.sale);
      parts.compare = strike;
    }
    if (parts.compare && selected.onSale) parts.compare.textContent = selected.comparePrice;
    scope.setAttribute('data-jmt-selected-variant-id', selected.id);
  }

  function update(scope, pref, key) {
    var context = scope.querySelector('[data-jmt-option-values]');
    var handle = context && context.dataset.jmtProductHandle;
    var optionIds = selectedOptionIds(scope, pref);
    if (!handle || !optionIds) {
      restore(scope);
      scope.setAttribute('data-jmt-price-ready', '');
      return;
    }
    selectedPrice(handle, optionIds).then(function (selected) {
      if (!scope.isConnected || key !== currentKey) return;
      render(scope, selected);
      scope.setAttribute('data-jmt-price-ready', '');
    }).catch(function () {
      if (key !== currentKey) return;
      scope.removeAttribute('data-jmt-price-ready');
    });
  }

  function refresh() {
    var pref = preference();
    var key = keyFor(pref);
    currentKey = key;
    if (visibleObserver) visibleObserver.disconnect();
    var scopes = document.querySelectorAll('[data-jmt-price-scope][data-jmt-variant-pricing="true"]');
    scopes.forEach(function (scope) {
      prepare(scope, pref, key, true);
    });
  }

  function prepare(scope, pref, key, reset) {
    if (reset) {
      scope.removeAttribute('data-jmt-price-ready');
      restore(scope);
    }
    if (!key) {
      scope.setAttribute('data-jmt-price-ready', '');
      return;
    }
    if (visibleObserver) visibleObserver.observe(scope);
    else update(scope, pref, key);
  }

  function queueRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(function () {
      refreshQueued = false;
      refresh();
    });
  }

  if ('IntersectionObserver' in window) {
    visibleObserver = new IntersectionObserver(function (entries) {
      var pref = preference();
      var key = keyFor(pref);
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        visibleObserver.unobserve(entry.target);
        if (key && key === currentKey) update(entry.target, pref, key);
      });
    }, { rootMargin: '240px 0px' });
  }

  new MutationObserver(function (mutations) {
    var selector = '[data-jmt-price-scope][data-jmt-variant-pricing="true"]';
    var scopes = new Set();
    mutations.forEach(function (mutation) {
      Array.prototype.forEach.call(mutation.addedNodes, function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches(selector)) scopes.add(node);
        node.querySelectorAll(selector).forEach(function (scope) {
          scopes.add(scope);
        });
      });
    });
    if (!scopes.size) return;
    var pref = preference();
    var key = keyFor(pref);
    if (key !== currentKey) {
      queueRefresh();
      return;
    }
    scopes.forEach(function (scope) {
      prepare(scope, pref, key, false);
    });
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('jmt:pref:change', queueRefresh);
  document.addEventListener('shopify:section:load', queueRefresh);
  refresh();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueRefresh, { once: true });
  }
})();

